/**
 * useInvoiceRows — TanStack Query hook for the Rechnungen-prüfen list (Story V10-J2).
 *
 * live mode → GET /invoices via the typed client (mapped to InvoiceRow).
 * mock mode → resolves the INVOICES_MOCK module (mock layer NOT deleted).
 *
 * [Source: apps/web/src/features/customers/hooks/useKundeRows.ts] (hook pattern)
 */

import { useQuery } from '@tanstack/react-query';
import { qk } from '../../../lib/query-keys';
import { isLiveData } from '../../../lib/data-mode';
import { fetchInvoiceRows } from '../api/invoices-api';
import { INVOICES_MOCK } from '../mock';
import type { InvoiceRow } from '../types';

export function useInvoiceRows() {
  const live = isLiveData();
  return useQuery<InvoiceRow[]>({
    queryKey: qk.invoices({ mode: live ? 'live' : 'mock' }),
    queryFn: () => (live ? fetchInvoiceRows() : Promise.resolve(INVOICES_MOCK)),
    // mock mode: synchronous initialData (no loading flicker, deterministic tests)
    ...(live ? {} : { initialData: INVOICES_MOCK, staleTime: Infinity }),
  });
}
